import React from 'react'
import Nav from './Nav'
import Logos from './Logos'
import ValueProp from './ValueProp'
import Howitworks from './Howitworks'
import Footer from './Footer'
import Hero from './Hero'
import CallToActions from './CallToActions'
import FAAQ from './FAAQ'
const LandingPage = () => {
  return (
    <div>
         <Nav/>
          <Hero/>
          <Logos/>
          <ValueProp/>
          <Howitworks/>
          <FAAQ/>
          <CallToActions/>
          <Footer/>
    </div>
  );
};

export default LandingPage;
